var render, staticRenderFns
import script from "./CustomFieldValue.vue?vue&type=script&lang=tsx&"
export * from "./CustomFieldValue.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c3a9844')) {
      api.createRecord('8c3a9844', component.options)
    } else {
      api.reload('8c3a9844', component.options)
    }
    
  }
}
component.options.__file = "src/components/_CustomFields/CustomFieldValue.vue"
export default component.exports